import 'bootstrap-slider/dist/bootstrap-slider';

(function () {

    var $fastcalc2Elements = $('.fastcalc2');

    if ($fastcalc2Elements.length === 0) {
        return;
    }

    function Fastcalc2(element) {
        this.$fastcalc2 = $(element);
        var self = this;

        this.uniqueId = $(element).attr('id');
        this.calculatorType = this.$fastcalc2.data('calculatorType');
        this.type = this.$fastcalc2.data('type');
        this.$typeChanger = this.$fastcalc2.find('.fastcalc2-type-changer');
        this.$tilesChangerWrapper = this.$fastcalc2.find('.tiles-changer-wrapper');
        this.$tilesCheckboxes = this.$fastcalc2.find('.tile input[type=checkbox]');

        //init range slider (employees, residental units,...)
        var $fastcalc2Slider = this.$fastcalc2.find(".fastcalc2-slider");
        if ($fastcalc2Slider.length) {
            $fastcalc2Slider.each(function (it,ele) {
               var $current = $(ele);
                $current.on("slide", function (slideEvt) {
                    $('#' + $current.data('target')).text(slideEvt.value);
                });
                $current.on("slideStop", function (slideEvt) {
                    $('#' + $current.data('target')).text(slideEvt.value);
                    self.getPrice();
                });
            });
        }

        //init Verkehr
        if(this.type === 'verkehr') {
            this.$sentenceVehicleContainer = this.$fastcalc2.find('.vehicle-container');
            this.$sentenceOneVehicle = this.$fastcalc2.find('.one-vehicle');
            this.$sentenceManyVehicle = this.$fastcalc2.find('.many-vehicle');
            this.$sentenceManyVehicle.remove();

            this.$fastcalc2.find('.vehicle-count-select').on('change',function () {
                var currentPBeruf = self.$sentenceVehicleContainer.find('[data-param-name="PBeruf"]').val();
                if($(this).val() === 'Ja') {
                    self.$sentenceOneVehicle.remove();
                    self.$sentenceVehicleContainer.append(self.$sentenceManyVehicle);
                }else{
                    self.$sentenceManyVehicle.remove();
                    self.$sentenceVehicleContainer.append(self.$sentenceOneVehicle);
                }
                self.$sentenceVehicleContainer.find('[data-param-name="PBeruf"]').val(currentPBeruf);
            });
        }


        //init combined/individual switch
        this.$typeChanger.on('change', function () {
            if ($(this).val() === 'individual') {
                self.$fastcalc2.find('.combined-show').hide();
                self.$tilesChangerWrapper.addClass('individual-tiles');
                self.$tilesChangerWrapper.removeClass('combined-tiles');
                self.$tilesCheckboxes.prop('disabled', false);
            } else {
                self.$fastcalc2.find('.combined-show').show();
                self.$tilesChangerWrapper.addClass('combined-tiles');
                self.$tilesChangerWrapper.removeClass('individual-tiles');
                self.$tilesCheckboxes.prop('checked', true);
                self.$tilesCheckboxes.prop('disabled', true);

            }
        });

        if(this.$typeChanger.filter(':checked').length > 0) {
            this.$typeChanger.filter(':checked').trigger('change');
        } else {
            this.$typeChanger.first().trigger('change');
        }

        this.$fastcalc2.on('change','.trigger-get-price', function () {
            self.getPrice();
        });

        this.getPrice();
    }

    Fastcalc2.prototype.getPrice = function () {
        var url = this.$fastcalc2.data('apiUrl');

        if(this.calculatorType === 'gewerblich') {
            url += 'k='+window.encodeURIComponent('Selbstständige') + '&';
        }else{
            url += 'k=Privatbereich&';
        }

        this.$tilesCheckboxes.each(function (it, ele) {
            url += window.encodeURIComponent($(ele).data('parameterName')) + '=' + ($(ele).is(':checked') ? 'true' : 'false') + '&';
        });

        this.$fastcalc2.find('[data-param-name2]').each(function (it, ele) {
            url += $(ele).data('paramName2') + '=' + window.encodeURIComponent($(ele).val()) + '&';
        });

        this.$fastcalc2.find('[data-param-name]').each(function (it, ele) {
            url += $(ele).data('paramName') + '=' + window.encodeURIComponent($(ele).val()) + '&';
        });

        url += 'PSelbstbeteiligung=250&';

        //eigener cache parameter, der von jquery führt bei der schnittstelle zu einem 302 redirect und die Daten werden nicht immer korrekt übernommen...
        url += '__ts=' + Date.now();


        var self = this;
        $.ajax({
            url: url,
            jsonpCallback: "callback",
            dataType: "jsonp",
            cache: true,
            success: function (price) {
                var formatedPrice = (price === 'null' || price === '') ? '-,--' : price;
                self.$fastcalc2.find('.fc-price').text(formatedPrice);
            }
        });
    };


    $fastcalc2Elements.each(function (it, ele) {
        var fastCalcInstance = new Fastcalc2(ele);
        $(ele).data('fastCalcInstance', fastCalcInstance);
    });

})();
